/* eslint-disable @next/next/no-sync-scripts */
import { getOrCreateUUID } from '@shared/utils';
import Head from 'next/head';
import React, { useState } from 'react';

export const ChatBot = () => {
  const [userId] = useState(getOrCreateUUID());

  return (
    <>
      <Head>
        <script src="https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1" />
        <meta name="viewport" content="width-device-width, initial-scale=1" />
      </Head>
      <div
        dangerouslySetInnerHTML={{
          __html: `
              <df-messenger
                intent="WELCOME"
                chat-icon="/images/chatbot-icon.svg"
                user-id="${userId}"
                chat-title="AptunoWeb"
                agent-id="ec1c54de-f1ea-4aff-826a-776a21e8f0c4"
                language-code="es" />
            `,
        }}
      />
    </>
  );
};
